class FAQSection extends HTMLElement {
  constructor() {
    super();
    this.filterButtons = this.querySelectorAll('.faq__filter-button');
    this.categories = this.querySelectorAll('.faq__category');
    this.accordions = this.querySelectorAll('.faq__accordion');
    this.searchInput = this.querySelector('[data-faq-search-input]');
    this.searchClearButton = this.querySelector('[data-faq-search-clear]');
    this.emptyState = this.querySelector('[data-faq-empty-state]');
    this.activeCategory = this.filterButtons[0]?.dataset.category || null;

    this.init();
  }

  init() {
    this.indexAccordionContent();

    this.filterButtons.forEach(button => {
      button.addEventListener('click', this.handleFilterClick.bind(this));
    });

    this.accordions.forEach(accordion => {
      const summary = accordion.querySelector('.faq__accordion-header');
      summary.addEventListener('click', this.handleAccordionClick.bind(this));
    });

    if (this.searchInput) {
      this.searchInput.addEventListener('input', this.handleSearchInput.bind(this));
    }

    if (this.searchClearButton) {
      this.searchClearButton.addEventListener('click', this.clearSearch.bind(this));
    }

    this.filterFaqs(this.normalizeText(this.searchInput?.value || ''));
  }

  handleFilterClick(event) {
    const button = event.target;
    const category = button.dataset.category;

    this.setActiveCategory(category);

    const categoryElement = this.querySelector(`.faq__category[data-category="${category}"]`);
    if (categoryElement) {
      categoryElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }

  handleSearchInput(event) {
    const query = this.normalizeText(event.target.value);
    this.filterFaqs(query);
  }

  clearSearch() {
    if (!this.searchInput) return;

    this.searchInput.value = '';
    this.searchInput.focus();
    this.filterFaqs('');
  }

  handleAccordionClick(event) {
    event.preventDefault();
    const accordion = event.target.closest('.faq__accordion');
    const isOpen = accordion.hasAttribute('open');

    // Close all other accordions in the same category
    const category = accordion.closest('.faq__category');
    const siblingAccordions = category.querySelectorAll('.faq__accordion');

    siblingAccordions.forEach(acc => {
      if (acc !== accordion) {
        acc.removeAttribute('open');
      }
    });

    // Toggle current accordion
    if (isOpen) {
      accordion.removeAttribute('open');
    } else {
      accordion.setAttribute('open', '');
    }
  }

  indexAccordionContent() {
    this.accordions.forEach((accordion) => {
      const question = accordion.querySelector('.faq__accordion-question')?.textContent || '';
      const answer = accordion.querySelector('.faq__accordion-answer')?.textContent || '';
      accordion.dataset.searchText = this.normalizeText(`${question} ${answer}`);
    });
  }

  normalizeText(value) {
    return value
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[.'&’]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  filterFaqs(query) {
    const hasQuery = query.length > 0;
    let visibleCategoryCount = 0;

    this.categories.forEach((category) => {
      const categoryHandle = category.dataset.category;
      const categoryButton = this.querySelector(`.faq__filter-button[data-category="${categoryHandle}"]`);
      let visibleAccordionCount = 0;

      category.querySelectorAll('.faq__accordion').forEach((accordion) => {
        const matches = !hasQuery || accordion.dataset.searchText.includes(query);
        accordion.hidden = !matches;

        if (!matches) {
          accordion.removeAttribute('open');
        } else {
          visibleAccordionCount += 1;
        }
      });

      const categoryVisible = visibleAccordionCount > 0;
      category.hidden = !categoryVisible;

      if (categoryButton) {
        categoryButton.hidden = !categoryVisible;
      }

      if (categoryVisible) {
        visibleCategoryCount += 1;
      }
    });

    if (this.searchClearButton) {
      this.searchClearButton.hidden = !hasQuery;
    }

    if (this.emptyState) {
      this.emptyState.hidden = visibleCategoryCount > 0;
    }

    this.syncActiveCategory();
  }

  syncActiveCategory() {
    const visibleButtons = Array.from(this.filterButtons).filter((button) => !button.hidden);
    const nextCategory = visibleButtons.find((button) => button.dataset.category === this.activeCategory)?.dataset.category
      || visibleButtons[0]?.dataset.category
      || null;

    this.setActiveCategory(nextCategory);
  }

  setActiveCategory(category) {
    this.activeCategory = category;

    this.filterButtons.forEach((button) => {
      const isActive = button.dataset.category === category;
      button.classList.toggle('faq__filter-button--active', isActive);
    });
  }
}

customElements.define('faq-section', FAQSection);
